<!-- =========================================================================================
  File Name: App.vue
  Description: Main vue file - APP
  ----------------------------------------------------------------------------------------
  Item Name: ESM - EASY SCHOOL MANAGEMENT
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->


<template>
  <div id="app" :class="vueAppClasses">
    <router-view @setAppClasses="setAppClasses" />
  </div>
</template>

<script>
let base_self = ''
import i18nData from '@/i18n/i18nData'
import themeConfig from '@/../themeConfig.js'
import jwt         from '@/http/requests/auth/jwt/index.js'

/* const ProjetWebSocket = function () {
  const chatSocket = window.createConnection(String(localStorage.getItem('high_pharma_ws_ip')) + 'Projet/')
  chatSocket.onmessage = function (e) {
    const data = JSON.parse(e.data)
    // console.log('data : ', data)
    if (data['created']) {
      createItem(data['instance'], 'ProjetsStore')
    } else {
      updateItem(data['instance'], 'ProjetsStore')
    }
  }
  chatSocket.onclose = function (e) { console.error('Chat socket closed unexpectedly', e) }
} */

export default {
  data () {
    return {
      vueAppClasses: []
    }
  },
  watch: {
    '$store.state.theme' (val) {
      this.toggleClassInBody(val)
    },
    '$vs.rtl' (val) {
      document.documentElement.setAttribute('dir', val ? 'rtl' : 'ltr')
    }
  },
  methods: {
    success (success, response) {
      this.$vs.loading.close()
      this.$vs.notify({
        time: 5000,
        title: this.$t('Success'),
        text: success,
        color: 'success',
        iconPack: 'feather',
        position: 'top-right',
        icon: 'icon-check-circle'
      })
      success = response // rein d'interressant
    },
    error (error) {
      this.$vs.loading.close()
  
      this.$vs.notify({
        time: 50000,
        title: this.$t('Failure'),
        text: error,
        color: 'danger',
        iconPack: 'feather',
        position: 'top-right',
        icon: 'icon-x-circle'
      })
    },
    // 
    toggleClassInBody (className) {
      if (className === 'dark') {
        if (document.body.className.match('theme-semi-dark')) document.body.classList.remove('theme-semi-dark')
        document.body.classList.add('theme-dark')
      } else if (className === 'semi-dark') {
        if (document.body.className.match('theme-dark')) document.body.classList.remove('theme-dark')
        document.body.classList.add('theme-semi-dark')
      } else {
        if (document.body.className.match('theme-dark'))      document.body.classList.remove('theme-dark')
        if (document.body.className.match('theme-semi-dark')) document.body.classList.remove('theme-semi-dark')
      }
    },
    setAppClasses (classesStr) {
      this.vueAppClasses.push(classesStr)
    },
    handleWindowResize () {
      this.$store.commit('UPDATE_WINDOW_WIDTH', window.innerWidth)

      // Set --vh property
      document.documentElement.style.setProperty('--vh', `${window.innerHeight * 0.01}px`)
    },
    handleScroll () {
      this.$store.commit('UPDATE_WINDOW_SCROLL_Y', window.scrollY)
    },
    initI18n () {
      window.getESM.$i18n.setLocaleMessage('fr', i18nData.fr)
      window.getESM.$i18n.setLocaleMessage('en', i18nData.en)
      window.getESM.$i18n.locale = 'fr'
    },
    mettreAJourUneSalle (id) {
      return new Promise((resolve, reject) => {
        const data1 = {
          is_get: true,
          filter: { id }
        }
        base_self.$http.post(`${base_self.$store.state.route_for_esm}Salle`, data1)
          .then((response1) => {
            const capacite = response1.data.data[0].capacite

            const data = {
              is_get: true,
              is_count: true,
              filter: { salle__id: id, anneeScolaire__id: base_self.$store.state.anneeScolaire.id, abandon: false }
            }
            base_self.$http.post(`${base_self.$store.state.route_for_esm}Inscription`, data)
              .then((response) => {
                const occupe = response.data.taille

                base_self.$http.put(`${base_self.$store.state.route_for_esm}Salle`, { id, pleine: occupe === capacite, occupe })
                  .then(() => {
                    resolve(true)
                  })
                  .catch(() => {
                    window.getESM.error(base_self.$t('The_server_is_not_responding'))
                    reject(false)
                  })
              })
              .catch(() => {
                window.getESM.error(base_self.$t('The_server_is_not_responding'))
                reject(false)
              })
          })
          .catch(() => {
            window.getESM.error(base_self.$t('The_server_is_not_responding'))
            reject(false)
          })
      })
        
    },
    rechercherAnneeEnCours () {
      const data = {
        is_get: true,
        filter: { encours: true, cloture: false }
      }
      base_self.$http.post(`${base_self.$store.state.route_for_esm}AnneeScolaire`, data)
        .then((response) => {
          if (response.data.data.length) {
            base_self.$store.dispatch('schoolYear', response.data.data[0])
            // console.log('base_self.$store.state.anneeScolaire: ', base_self.$store.state.anneeScolaire)
          }
        })
        .catch((error) => {
          window.getESM.error(base_self.$t('The_server_is_not_responding'))

          /* console.log(' +++++++++++++++++++++++++++++++++++++++++++++++++++++++++++ error')
          console.log(' +++++++++++++++++++++++++++++++++++++++++++++++++++++++++++ error')
          console.log(' +++++++++++++++++++++++++++++++++++++++++++++++++++++++++++ error')
          console.log(' +++++++++++++++++++++++++++++++++++++++++++++++++++++++++++ error') */
          console.log('Object.keys(error): ', Object.keys(error))
          localStorage.setItem('accessToken', '')
          
          base_self.$router.push('/pages/login').catch(() => {})

          this.datas = []
          this.taille = 0
          this.show = false
          // console.log(' ------------ ', this.show)

        })
    },
    getParametre () {
      const data = {
        is_get: true,
        filter: { unique: 0 }
      }
      base_self.$http.post(`${base_self.$store.state.route_for_esm}Parametre`, data)
        .then((response) => {
          const item = response.data.data[0]
          item.ecole = JSON.parse(item.ecole)

          base_self.$store.dispatch('parametreEcole', item)

          localStorage.setItem('parametre', JSON.stringify(item.ecole))
        })
        .catch((error) => {
          console.log('error: ', error)
        })
    },
    initialisation () {
      base_self.rechercherAnneeEnCours()
      base_self.getParametre()
    }
  },
  mounted () {
    // console.log('this.$http.defaults.baseURL: ', this.$http.defaults.baseURL)
    this.toggleClassInBody(themeConfig.theme)
    this.$store.commit('UPDATE_WINDOW_WIDTH', window.innerWidth)

    const vh = window.innerHeight * 0.01
    // Then we set the value in the --vh custom property to the root of the document
    document.documentElement.style.setProperty('--vh', `${vh}px`)
  },
  async created () {
    base_self = this
    // base_self.rechercherAnneeEnCours()
    // console.log('window.createConnection: ', window.createConnection)
    // ProjetWebSocket()

    window.getESM = this
    if (localStorage.getItem('accessToken') && (localStorage.getItem('accessToken') !== null) && localStorage.getItem('accessToken').length) {
      base_self.initialisation()
    }
    base_self.initI18n()
    // this.initI18n()
    // jwt
    jwt.init()

    const dir = this.$vs.rtl ? 'rtl' : 'ltr'
    document.documentElement.setAttribute('dir', dir)

    window.addEventListener('resize', this.handleWindowResize)
    window.addEventListener('scroll', this.handleScroll)

    // Auth0
    try       { await this.$auth.renewTokens() } catch (e) { console.error(e) }

  },
  destroyed () {
    window.removeEventListener('resize', this.handleWindowResize)
    window.removeEventListener('scroll', this.handleScroll)
  }
}

</script>

<style>
.vs-input--input {
  border-radius: 20px;
  padding: 0.9rem 2.5rem;
  font-size: 1rem;
}

[dir] .vs__dropdown-toggle {
  border-radius: 20px;
}

[dir] .vdp-datepicker input {
  border-radius: 20px;
}
</style>